/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import { Reducer } from "redux";
import *as actionsTypesFromStore from '@apps-store/@types';
import { ReducersInterface } from '@apps-store/models';
import * as actions from '@apps-store/enums';

/**
 * @function DeconnexionReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeDeconnexionAction } action: action de l'application
 * @return { Reducer }
 */
export const DeconnexionReducer: Reducer< ReducersInterface<any>> = ( state: any = {
   
} , action: actionsTypesFromStore.TypeDeconnexionAction) => {
    
    switch (action.type) {

        case actions.DeconnexionTypes.DECONNEXION_INPROGRESS:

            return {

                loading: true,
                ...state

            }
            
            break;
        case actions.DeconnexionTypes.DECONNEXION_FAIL:

            return {

                error: action.payload.error ,
                loading: false,
                
            }
            
            break;
        
        case actions.DeconnexionTypes.DECONNEXION_SUCCESS:

            return {

                data: action.payload.data ,
                loading: false,
                
            }
            
            break;
    
        default:
            return state
            break;
    }
    
}


// WEBPACK FOOTER //
// ./src/apps/store/reducers/logout/index.ts